// Change root App component here
// import { default as App } from 'base/browser/app/App'

// export default App

module.exports = require(`../../${process.env.MAIN_MODULE}/_config/browser/App`)
